import { render, staticRenderFns } from "./manageDialog.vue?vue&type=template&id=2a10c325&scoped=true"
import script from "./manageDialog.vue?vue&type=script&lang=js"
export * from "./manageDialog.vue?vue&type=script&lang=js"
import style0 from "./manageDialog.vue?vue&type=style&index=0&id=2a10c325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10c325",
  null
  
)

export default component.exports